import type { CSSProperties } from 'react';

export type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  /** Override the accent color. Defaults to --ice-500. */
  color?: string;
  style?: CSSProperties;
}

const dims: Record<SpinnerSize, { px: number; border: number }> = {
  sm: { px: 16, border: 2 },
  md: { px: 22, border: 2 },
  lg: { px: 32, border: 3 },
};

export default function Spinner({ size = 'md', color, style }: SpinnerProps) {
  const d = dims[size];
  const accent = color ?? 'var(--ice-500, oklch(0.66 0.150 205))';
  return (
    <div
      role="status"
      aria-label="Loading"
      style={{
        width: d.px,
        height: d.px,
        borderRadius: '50%',
        borderStyle: 'solid',
        borderWidth: d.border,
        borderTopColor: accent,
        borderLeftColor: accent,
        borderRightColor: accent,
        borderBottomColor: 'transparent',
        animation: 'serac-spin 720ms linear infinite',
        ...style,
      }}
    />
  );
}
